import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";

const rootElement = document.getElementById("root");
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Prerendering captures the settled browser DOM, not React server-rendered HTML.
// Mount every route normally: router loaders and form effects can produce a
// different initial render from the snapshot. Static HTML remains available
// to crawlers and visitors with JavaScript disabled.
rootElement.replaceChildren();
createRoot(rootElement).render(app);
